import $ from 'jquery'
import 'bootstrap-notify'

// Make plugin globally available
window.jQuery.notify = $.notify;
window.jQuery.notifyDefaults = $.notifyDefaults;
window.jQuery.notifyClose = $.notifyClose;
